import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withKeys as _withKeys, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../assets/images/logo.png'


const _hoisted_1 = { class: "nav-bar-content" }
const _hoisted_2 = { class: "nav-bar-box" }
const _hoisted_3 = { class: "right-menu-list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "text-right" }
const _hoisted_6 = { class: "phone-menu-icon display-none" }

import { UtilMethods } from '@/util/UtilMethods'
import { Search } from '@element-plus/icons-vue'
import { onBeforeMount, ref, Ref } from 'vue'
import { Action, LanguageType, RouterUnion } from '@/typeDefine/CommonTypes'
import { NavMenuType } from '@/typeDefine/EntityType'
import { useI18n } from 'vue-i18n'
import { LanguagePackageType } from '@/typeDefine/EntityType'
import { Translate } from '@/locale/Translate'
import { router, routes } from '@/router'


export default /*@__PURE__*/_defineComponent({
  __name: 'NavBar',
  setup(__props) {

const {locale} = useI18n<[LanguagePackageType], LanguageType>()

//语言切换标志
const isEn: Ref<boolean> = ref(false)

//获取系统默认色
const primaryColor: string = UtilMethods.getDOMStyleFromCSS('--primary-color')

//菜单项
const menuList: Readonly<Array<NavMenuType>> = [
    {
        title: 'home',
        path: '/'
    },
    {
        title: 'aboutUs',
        path: '/aboutUs'
    },
    {
        title: 'product',
        path: '/products'
    },
    {
        title: 'news',
        path: '/newsList'
    },
    {
        title: 'contactUs',
        path: '/contactUs'
    }
]

//用户搜索内容
const searchValue: Ref<string> = ref('')

onBeforeMount(() => initLanguage())

const gotoHome: Action = () => {
    router.push({
        name: 'index'
    })
}

//触发搜索点击事件
const onSearchClickHandler: Action<[]> = () => {
    router.push({
        name: 'products',
        query: {
            keyword: searchValue.value
        }
    })
}

//初始化获取语言设置
const initLanguage: Action<[]> = () => {
    const language: LanguageType = Translate.instance.getLanguageFromLocal()
    locale.value = language
    isEn.value = language === 'en'
}

//切换语言事件
const onTranslateChange: Action<[boolean]> = (value: boolean) => {
    locale.value = value ? 'en' : 'zh'
    Translate.instance.setLanguage2Local(locale.value)
}

const goPage: Action<[RouterUnion<typeof routes,'path'>]> = (path) => {
    router.push({
        path
    })
}


return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "left-logo pointer-cursor",
        onClick: gotoHome
      }, _cache[2] || (_cache[2] = [
        _createElementVNode("img", { src: _imports_0 }, null, -1)
      ])),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", null, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuList, (item, index) => {
            return _createElementVNode("li", {
              key: index,
              onClick: ($event: any) => (goPage(item.path))
            }, _toDisplayString(_ctx.$t(`index.navBar.${item.title}`)), 9, _hoisted_4)
          }), 64)),
          _createElementVNode("li", _hoisted_5, [
            _createVNode(_component_el_input, {
              modelValue: searchValue.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchValue).value = $event)),
              placeholder: "Search Products",
              class: "search-input",
              onKeydown: _withKeys(onSearchClickHandler, ["enter"])
            }, {
              suffix: _withCtx(() => [
                _createVNode(_component_el_icon, {
                  onClick: onSearchClickHandler,
                  class: "pointer-cursor"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Search))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_el_switch, {
              modelValue: isEn.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isEn).value = $event)),
              "inline-prompt": "",
              "active-text": "En",
              "inactive-text": "中",
              onChange: onTranslateChange,
              style: _normalizeStyle({
                            '--el-switch-off-color': _unref(primaryColor),
                            '--el-switch-on-color': '#FBBA0E',
                        })
            }, null, 8, ["modelValue", "style"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_dropdown, { size: "large" }, {
            dropdown: _withCtx(() => [
              _createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuList, (item, index) => {
                    return _createVNode(_component_el_dropdown_item, {
                      key: index,
                      onClick: ($event: any) => (goPage(item.path))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t(`index.navBar.${item.title}`)), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  }), 64))
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_icon, {
                size: 20,
                class: "pointer-cursor border-outline-none",
                color: _unref(primaryColor)
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Menu)
                ]),
                _: 1
              }, 8, ["color"])
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})